var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLinkOutlined(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.229,
    height: 23.176,
    viewBox: "0 0 23.229 23.176",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_8263",
    "data-name": "Group 8263",
    transform: "translate(-3327.657 -78.064)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8262",
    "data-name": "Group 8262",
    transform: "translate(3327.657 78.064)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_16863",
    "data-name": "Path 16863",
    d: "M3333.113,121.956a5.456,5.456,0,0,1-3.878-9.277c.723-.765,1.481-1.5,2.231-2.235a1.155,1.155,0,0,1,1.717-.12,1.116,1.116,0,0,1-.108,1.711c-.719.742-1.456,1.465-2.183,2.2a3.2,3.2,0,1,0,4.522,4.519c1.749-1.744,3.5-3.485,5.237-5.242a3.133,3.133,0,0,0,.138-4.52,1.166,1.166,0,0,1-.045-1.684,1.143,1.143,0,0,1,1.717.14,5.333,5.333,0,0,1,.141,7.288c-1.909,2.038-3.91,3.993-5.921,5.931A4.843,4.843,0,0,1,3333.113,121.956Z",
    transform: "translate(-3327.657 -98.781)",
    fill: "#7e97b8",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16864",
    "data-name": "Path 16864",
    d: "M3364.842,78.064a5.323,5.323,0,0,1,5,3.326,5.434,5.434,0,0,1-1.092,5.921q-.76.786-1.544,1.547a1.149,1.149,0,0,1-1.72.067,1.126,1.126,0,0,1,.121-1.669c.45-.466.91-.922,1.367-1.381a3.2,3.2,0,1,0-4.538-4.5q-2.191,2.19-4.379,4.381a3.14,3.14,0,0,0-.162,4.52,1.158,1.158,0,0,1,.031,1.723,1.13,1.13,0,0,1-1.711-.189,5.374,5.374,0,0,1-.061-7.338c1.625-1.722,3.317-3.383,5.021-5.027A5.022,5.022,0,0,1,3364.842,78.064Z",
    transform: "translate(-3347.061 -78.064)",
    fill: "#7e97b8",
    fillRule: "evenodd"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkOutlined);
export default __webpack_public_path__ + "static/media/LinkOutlined.bf4a6ad572f23a169844923a94816248.svg";
export { ForwardRef as ReactComponent };